const MAX_HEIGHT = '70vh';

export const sizes = {
  auto: 'auto',
  small: '23.75rem',
  medium: '40rem',
  large: '50rem',
};

export const themes = {
  default: ({ size }) => ({
    thRoot: 'fadeIn flex relative scaleIn',
    thRootStyles: {
      width: sizes[size],
      maxWidth: '100%',
      maxHeight: MAX_HEIGHT,
      minHeight: 100,
    },
    thCloseButton:
      'absolute bg-white border-1 cursor-pointer leading-none top-0 mb-3 rtl:right-0 p-1 reset-button rounded-full z-1',
    thCloseButtonLabel: 'a11y',
    thCloseButtonStyles: {
      top: 'auto',
      bottom: '100%',
      width: 40,
      height: 40,
    },
    thBody: 'bg-white max-h-full relative overflow-hidden rounded-tiny shadow w-full',
    thBodyStyles: {
      maxHeight: MAX_HEIGHT,
    },
    // ⚠️ relative is only needed to prevent a weird bug of reflow on chrome
    thContent: 'max-h-full overflow-auto w-full relative',
  }),
};
